import { getConfig, getErrorMessage, klinikenApi } from "@/api";
import { openDialog } from "@/utils";
import URLSearchParams from "@ungap/url-search-params";

const getDefaultParameters = () => {
    return {};
};

const getDefaultState = () => {
    return {
        kvakoder: [],
        count: 0,
        limit: 100,
        offset: 0,
        parameters: getDefaultParameters(),
    };
};

export default {
    namespaced: true,
    state: getDefaultState(),
    getters: {
        kvakoder(state) {
            return state.kvakoder;
        },
        count(state) {
            return Math.ceil(state.count);
        },
        limit(state) {
            return state.limit;
        },
        offset(state) {
            return state.offset;
        },
        parameters(state) {
            return state.parameters;
        },
        kvakod(state) {
            return state.kvakod;
        },
    },
    mutations: {
        reset(state) {
            Object.assign(state, getDefaultState());
        },
        setKVAKoder: (state, kvakoder) => {
            state.kvakoder = kvakoder;
        },
        setCount: (state, count) => {
            state.count = count;
        },
        setLimit: (state, limit) => {
            state.limit = limit;
        },
        setOffset: (state, offset) => {
            state.offset = offset;
        },
        setParameters: (state, parameters) => {
            state.parameters = parameters;
        },
        resetParameters(state) {
            state.parameters = getDefaultState();
        },
    },
    actions: {
        async load({ commit, state }, failSilently = false) {
            try {
                const qs = new URLSearchParams(state.parameters);
                qs.set("limit", state.limit);
                qs.set("offset", state.offset);

                const response = await klinikenApi.get(`core/kodverk/kvakoder/?${qs}`, getConfig());
                commit("setKVAKoder", response.data.results);
                commit("setCount", response.data.count);
            } catch (e) {
                if (!failSilently) {
                    openDialog("Kunde inte hämta KVÅKod." + getErrorMessage(e), "warning");
                }
            }
        },
        setOffset: ({ commit }, offset) => {
            commit("setOffset", offset);
        },
        setParameters: ({ commit }, parameters) => {
            commit("setParameters", parameters);
        },
        resetParameters({ commit }) {
            commit("resetParameters");
        },
        async save(context, data) {
            try {
                const response = await klinikenApi.post(`core/kodverk/kvakoder/`, data.kvakod, getConfig());
                return response;
            } catch (e) {
                openDialog("Kunde inte spara KVÅKod: " + getErrorMessage(e), "warning");
            }
        },
        async update(context, data) {
            try {
                const response = await klinikenApi.put(
                    `core/kodverk/kvakoder/${data.kvakod.id}/`,
                    data.kvakod,
                    getConfig()
                );
                return response;
            } catch (e) {
                openDialog("Kunde inte uppdatera KVÅKod: " + getErrorMessage(e), "warning");
            }
        },
    },
};
